import { ClassificationRunSchema } from "@redotech/redo-model/landed-cost/landed-cost-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getLcgClassifyStatus = {
  name: "getLcgClassifyStatus" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    isClassifying: z.boolean(),
    workflowStartTime: z.date().nullable(),
    classificationRun: ClassificationRunSchema.nullable(),
  }),
};
